export default __webpack_public_path__ + "static/media/PFDINTextPro-Black.113785fb.otf";